module.exports = __webpack_public_path__ + "imgs/white-leaf.e06fb88471892548f31099d12549a70e.svg";